import React from 'react';

const ContentfulCallButton = (props) => {
    const { buttonStyle, buttonText, phoneNumber } = props;

    return (
        <div className="call-btn">
            <a className={buttonStyle?.toLowerCase?.()} href={`tel:${phoneNumber}`}><span>{buttonText}</span></a>
        </div>
    )
};

export { ContentfulCallButton };
